import { DisplayErrorCode } from '../getDisplayError';

class ApiError extends Error {
  statusCode: number;
  displayCode: DisplayErrorCode;
  displayMessage: string;

  constructor(
    message: string,
    statusCode: number,
    displayCode: DisplayErrorCode,
    displayMessage: string,
  ) {
    super(message);
    this.statusCode = statusCode;
    this.displayCode = displayCode;
    this.displayMessage = displayMessage;
  }
}

export default ApiError;
